<script setup>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import InvoiceItemEntry from "./InvoiceItems.vue";

defineProps({
  onSave: {
    type: Function,
    required: true,
    // default() {
    //   return 'Default function'
    // }
  },
  onAddItem: {
    type: Function,
    required: true,
  },
  onRemoveItem: {
    type: Function,
    required: true,
  },
})

const Invoice = defineModel({
  Id: "0",
  InvoiceNumber: "",
  ClientName:"",
  ClientAddress: "",
  InvoiceDate:"",
  TotalAmount:"0",
  Items:[],
});

// const formattedTotalAmount = computed({
//   get: () => Invoice.value.TotalAmount.toString(), // Konwertuj liczbę na ciąg znaków
//   set: (value) => (Invoice.value.TotalAmount = parseFloat(value)), // Konwertuj ciąg znaków z powrotem na liczbę
// });

</script>
<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center">
        <p class="text-uppercase text-sm">InvoiceNumber: <label for="example-text-input" class="form-control-label">{{ Invoice.InvoiceNumber }}</label></p>
        <argon-button color="success" size="sm" class="ms-auto">Settings</argon-button>
      </div>
    </div>
    <hr class="horizontal dark" />
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <label for="example-text-input" class="form-control-label">ClientName</label>
          <argon-input type="text" v-model="Invoice.ClientName" placeholder="Type here..." />
        </div>
        <div class="col-md-3">
          <label for="example-text-input" class="form-control-label">ClientAddress</label>
          <argon-input type="text" v-model="Invoice.ClientAddress" placeholder="Type here..."/>
        </div>
        <div class="col-md-3">
          <label for="example-text-input" class="form-control-label">InvoiceDate</label>
          <argon-input type="datetime" v-model="Invoice.InvoiceDate" placeholder="Type here..."/>
        </div>
        <div class="col-md-3">
          <label for="example-text-input" class="form-control-label">TotalAmount</label>
          <argon-input type="text" v-model="Invoice.TotalAmount" placeholder="Type here..."/>
        </div>
      </div>
      <hr class="horizontal dark" />
      <p class="text-uppercase text-sm">Inovice Items</p>
      <invoice-item-entry v-model="Invoice.Items" :onAddItem="onAddItem" :onRemoveItem="onRemoveItem"/>
      <hr class="horizontal dark" />
      <p class="text-uppercase text-sm">Descritpion</p>
      <div class="row">
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label">More Info</label>
          <input type="text" class="form-control" value="A beautiful Dashboard for Bootstrap 5. It is Free and Open Source."
          />
        </div>
      </div>
    </div>
    <!-- <div class="card-header pb-4">
      <div class="d-flex align-items-center">
        <argon-button color="success" size="sm" class="ms-auto" @click="onSave">Save</argon-button>
      </div>
    </div> -->
  </div>
</template>
